const studyPhaseMapping: Record<string, string> = {
  I: 'Phase 1',
  IA: 'Phase 1',
  IB: 'Phase 1',
  'I/IB': 'Phase 1',
  'IB/IIA': 'Phase 2',
  'I/II': 'Phase 2',
  II: 'Phase 2',
  'II/IIA': 'Phase 2',
  IIA: 'Phase 2',
  IIB: 'Phase 2',
  'II/III': 'Phase 3',
  III: 'Phase 3',
  IIIA: 'Phase 3',
  IIIB: 'Phase 3',
  'IIIB/IV': 'Phase 4'
};

function mapRomanToPhase(phase: string): string {
  return studyPhaseMapping[phase.toUpperCase()] || phase;
}

function getRomansForPhase(simpleLabel: string): string[] {
  const label = simpleLabel?.toString() || '';
  return Object.keys(studyPhaseMapping).filter((roman) => studyPhaseMapping[roman] === label);
}

export { getRomansForPhase, mapRomanToPhase };
